export const KEY = 'toolrides_widget1_v5';
export const DOMAIN = 'demo.toolrides.com';
export const VERSION_CODE = 2;
export const DEBUG = process.env.NODE_ENV === "development";